import type { Sentiment } from '@marnic/shared';

const SENTIMENT_STYLE: Record<Sentiment, string> = {
  positive: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  neutral: 'bg-ink-100 text-ink-700 border-ink-200',
  negative: 'bg-red-100 text-red-800 border-red-200',
  mixed: 'bg-amber-100 text-amber-800 border-amber-200',
};

export function SentimentChip({ label, sentiment, score }: { label: string; sentiment: Sentiment | null; score: number | null }): JSX.Element | null {
  if (!sentiment) return null;
  const style = SENTIMENT_STYLE[sentiment];
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium ${style}`}
      title={score !== null ? `${label} score ${score.toFixed(2)}` : label}
    >
      <span className="text-ink-500">{label}</span>
      <span className="capitalize">{sentiment}</span>
    </span>
  );
}

export function sentimentStyle(s: Sentiment): string {
  return SENTIMENT_STYLE[s];
}
